import React, { Children } from 'react';
import { useInView } from 'react-intersection-observer';
import { MicroscopeIcon, CheckCircleIcon, ClipboardCheckIcon } from 'lucide-react';
export const ResearchApproach = () => {
  const [ref, inView] = useInView({
    triggerOnce: true,
    threshold: 0.1
  });
  return <section id="research" className="py-20 bg-gray-50" data-id="element-1675">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-1676">
        <div className="text-center mb-16" data-id="element-1677">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4" data-id="element-1678">
            Our Research Approach
          </h2>
          <div className="w-20 h-1 bg-blue-600 mx-auto mb-6" data-id="element-1679"></div>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto" data-id="element-1680">
            We apply pharmaceutical-grade research methodologies to evaluate
            wellness products and supplements
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-1681">
          <div className="bg-white p-8 rounded-lg shadow-lg hover:shadow-xl transition-shadow duration-300" data-id="element-1682">
            <div className="text-blue-600 mb-4" data-id="element-1683">
              <MicroscopeIcon size={48} data-id="element-1684" />
            </div>
            <h3 className="text-xl font-semibold mb-4 text-gray-900" data-id="element-1685">
              Rigorous Testing
            </h3>
            <p className="text-gray-700" data-id="element-1686">
              We employ advanced laboratory techniques and clinical
              methodologies to evaluate the efficacy, safety, and
              bioavailability of microbiome-targeted products.
            </p>
          </div>
          <div className="bg-white p-8 rounded-lg shadow-lg hover:shadow-xl transition-shadow duration-300" data-id="element-1687">
            <div className="text-blue-600 mb-4" data-id="element-1688">
              <CheckCircleIcon size={48} data-id="element-1689" />
            </div>
            <h3 className="text-xl font-semibold mb-4 text-gray-900" data-id="element-1690">
              Evidence-Based Certification
            </h3>
            <p className="text-gray-700" data-id="element-1691">
              Our Ukweli Certified™ program provides a three-tier evidence seal
              that clearly communicates the scientific backing behind each
              evaluated product.
            </p>
          </div>
          <div className="bg-white p-8 rounded-lg shadow-lg hover:shadow-xl transition-shadow duration-300" data-id="element-1692">
            <div className="text-blue-600 mb-4" data-id="element-1693">
              <ClipboardCheckIcon size={48} data-id="element-1694" />
            </div>
            <h3 className="text-xl font-semibold mb-4 text-gray-900" data-id="element-1695">
              Transparent Reporting
            </h3>
            <p className="text-gray-700" data-id="element-1696">
              We publish comprehensive reports detailing our methodologies,
              findings, and recommendations, making complex scientific data
              accessible to all stakeholders.
            </p>
          </div>
        </div>
      </div>
    </section>;
};